import React, { Fragment } from 'react';
import styled from 'react-emotion';

const stockColors = {
  inStock: ({ theme }) => theme.colors.themeGreen,
  outOfStock: '#EB5757',
  notifyWhenBack: '#F2C94C'
};

const StockIconCheck = styled('span')`
  display: inline-block;
  height: 17px;
  width: 9px;
  border-bottom: 3px solid ${({ status }) => stockColors[status]};
  border-right: 3px solid ${({ status }) => stockColors[status]};
  transform: rotate(45deg);
  transition: all 0.2s linear;
`;

const StockIconCross = styled('span')`
  position: relative;
  display: inline-block;
  top: 1px;
  width: 16px;
  height: 16px;

  &::before,
  &::after {
    position: absolute;
    top: 0;
    left: 6px;
    content: ' ';
    height: 18px;
    width: 3px;
    background-color: ${({ status }) => stockColors[status]};
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

const StockBadge = styled('div')`
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  background: ${({ status }) => stockColors[status]} !important;
  border-radius: 50%;
  //overflow: hidden;

  .icon-check {
    position: absolute;
    left: 7px;
    top: 4px;
    height: 10px;
    width: 6px;
    border-bottom: 2px solid #fff;
    border-right: 2px solid #fff;
  }

  .icon-cross {
    position: absolute;
    left: 4px;
    top: 4px;
    width: 11px;
    height: 11px;

    &::before,
    &::after {
      background: white;
      left: 5px;
      height: 12px;
      width: 2px;
    }
  }
`;

const StockOrb = ({ status, badge }) => (
  <Fragment>
    {badge ? (
      <StockBadge className="stock-badge" status={status}>
        {status === 'inStock' ? (
          <StockIconCheck className="icon-check" status={status} />
        ) : (
          <StockIconCross className="icon-cross" status={status} />
        )}
      </StockBadge>
    ) : status === 'inStock' ? (
      <StockIconCheck className="icon-check" status={status} />
    ) : (
      <StockIconCross className="icon-cross" status={status} />
    )}
  </Fragment>
);

export default StockOrb;
